import { createEvent, createStore } from 'effector';

export const $currentQuestionPath = createStore<string | null>(null);

export const setCurrentQuestionPath = createEvent<string>();

$currentQuestionPath.on(setCurrentQuestionPath, (_, path) => path);
